export default "__VITE_ASSET__e12444f8__"